// Create / edit a time-off block (a closed period that removes overlapping slots).
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from '../../../components/shared/Modal';
import { createBlock, updateBlock } from '../callScheduleService';

const Field = styled.div`
  margin-bottom: 14px;
  label { display: block; font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: ${p => p.theme.colors.textSecondary}; margin-bottom: 6px; }
  input {
    width: 100%; padding: 9px 12px; font-size: 0.9rem; box-sizing: border-box;
    background: ${p => p.theme.colors.background}; color: ${p => p.theme.colors.textPrimary};
    border: 1.5px solid ${p => p.theme.colors.inputGray}44; border-radius: ${p => p.theme.borderRadius};
  }
  .react-datepicker-wrapper { width: 100%; }
`;

const ErrorText = styled.div`color: ${p => p.theme.colors.error}; font-size: 0.82rem; margin-bottom: 10px;`;

const BlockEditor = ({ isOpen, block = null, onClose, onSaved }) => {
  const isEdit = !!block;
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    setError('');
    if (block) {
      setStart(block.starts_at ? new Date(block.starts_at) : null);
      setEnd(block.ends_at ? new Date(block.ends_at) : null);
      setReason(block.reason || '');
    } else {
      setStart(null); setEnd(null); setReason('');
    }
  }, [isOpen, block]);

  const save = async () => {
    if (!start || !end) { setError('Pick a start and end.'); return; }
    if (end <= start) { setError('End must be after start.'); return; }
    try {
      const body = { starts_at: start.toISOString(), ends_at: end.toISOString(), reason: reason.trim() || null };
      if (isEdit) await updateBlock(block.id, body);
      else await createBlock(body);
      onSaved?.(isEdit ? 'Time off updated' : 'Time off added');
      onClose?.();
    } catch (err) {
      setError(err.response?.data?.message || 'Could not save the block.');
    }
  };

  if (!isOpen) return null;

  return (
    <Modal title={isEdit ? 'Edit Time Off' : 'Add Time Off'} isOpen={isOpen} onCancel={onClose} onConfirm={save}>
      {error && <ErrorText>{error}</ErrorText>}
      <Field>
        <label>Starts (Eastern)</label>
        <DatePicker selected={start} onChange={setStart} showTimeSelect timeIntervals={15}
          dateFormat="EEE, MMM d, yyyy h:mm aa" placeholderText="Start of time off" />
      </Field>
      <Field>
        <label>Ends (Eastern)</label>
        <DatePicker selected={end} onChange={setEnd} showTimeSelect timeIntervals={15}
          dateFormat="EEE, MMM d, yyyy h:mm aa" placeholderText="End of time off" minDate={start || undefined} />
      </Field>
      <Field>
        <label>Reason (optional)</label>
        <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Holiday, lunch, vacation…" />
      </Field>
    </Modal>
  );
};

export default BlockEditor;
